module.exports = __webpack_public_path__ + "static/knowledgeProduct-d231e3c6eee3cda287b484c5c34b4e34.png";